import { css } from '@emotion/core'
import { colors, measures, font, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

export const select = {
  control: (state) => {
    if (state.isDisabled) {
      return { backgroundColor: 'transparent' }
    }
  },

  indicatorsContainer: (state) => {
    if (state.isDisabled) {
      return { display: 'none' }
    }
  },
}

export const control = css`
  width: 100%;
  &:disabled {
    background-color: transparent;
  }
`

export const heading = css`
  font-weight: ${font.weight.bold};
  font-size: ${spacing(3.25)};
  font-style: italic;
  margin-bottom: ${spacing(2)};
  color: ${colors.white};
  letter-spacing: 0.5px;
`

export const fieldLabel = css`
  font-weight: ${font.weight.normal};
  font-size: 16px;
  color: ${colors.white};
  margin-bottom: ${spacing(1)};
  letter-spacing: 0.2px;
`

export const row = css`
  display: flex;
  flex-direction: column;
  min-height: ${8 * unit}px;
  margin-bottom: ${spacing(1.5)};
  
  ${MQ.PHONES} {
    justify-content: space-between;
  }

  & label {
    min-width: ${14 * unit}px;
    margin-bottom: ${2 * unit}px;
    max-width: ${14 * unit}px;
  }
`

export const subRow = css`
  margin-top: ${unit}px;
  > span {
    color: ${colors.white60};
  }
`

export const buttonContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${spacing(4)};
  
  & button {
    width: 100%;
    text-transform: uppercase;
    font-weight: ${font.weight.bold};
    letter-spacing: 1px;
    padding: ${spacing(1.2)} ${spacing(2)};
  }

  ${MQ.NOT_PHONES} {
    margin: ${spacing(1, 2)};
  }
`
